import type * as THREE from "three";

abstract class Shape {
	public abstract readonly sceneObject: THREE.Object3D;

	public abstract dispose(): void;

	public abstract update({ currentPoint, confirmPoint }: { currentPoint: THREE.Vector3; confirmPoint?: boolean }): void;
	public abstract finish(): void;

	public abstract select(): void;
	public abstract deselect(): void;

	/** Rebuilds the visual representation of the shape using its current data representation. */
	protected abstract syncShapeView(): void;
}

export { Shape };
